import { useMutation } from "urql";

import { DeletePaymasterDocument } from "../../../graphql/generated.ts";

export function useDeletePaymaster() {
  return useMutation(DeletePaymasterDocument);
}
